"use client"
import React, {useState} from 'react';
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "@/components/ui/tooltip";
import {Button} from "@/components/ui/button";
import {Dialog, DialogContent, DialogHeader, DialogTitle} from "@/components/ui/dialog"
import {cn} from "@/lib/utils";
import {usePathname} from "next/navigation";
import useCopyText from "@/hook/useCopyText";
import Image from "next/image";
import productShareIcon from "@/public/icons/product-share.svg"
import {SingleProductEnum} from "@/constants/commerce-enum";
import {DataLayerFactory} from "@/components/google-tag-manager/DataLayerFactory";


const ProductShare = () => {

    const [isOpen, setIsOpen] = useState(false);
    const pathname = usePathname();
    const productUrl = process.env.Production_url + pathname;
    const copyText = useCopyText();

    const openHandler = () => setIsOpen(!isOpen);

    const copyUrl = () => {
        copyText(productUrl);
        DataLayerFactory.make('share', 'URL', 'image', productUrl);
        setIsOpen(false);
    }

    return (
        <>
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            variant={"default"}
                            onClick={openHandler}
                            className={"text-global-text-color bg-lite-gray md:bg-gray-100 hover:bg-gray-200 shadow-none gray-background w-[48px] p-3 h-[48px] rounded-2xl"}
                        >
                            <Image src={productShareIcon} alt={"share url"} title={"share url"}/>
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>{SingleProductEnum?.share} </p>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>

            {/*Modal*/}
            <Dialog open={isOpen} onOpenChange={setIsOpen}>
                <DialogContent className={"rounded-xl"}>
                    <DialogHeader>
                        <DialogTitle className={cn("text-right text-sm md:text-lg font-semibold")}>
                            {SingleProductEnum?.share}
                        </DialogTitle>
                    </DialogHeader>
                    <Button
                        variant={"outline"}
                        className={"mx-10 h-12 mb-5 my-5 rounded-2xl"}
                        onClick={copyUrl}>
                        {SingleProductEnum?.copyLink}
                    </Button>
                </DialogContent>
            </Dialog>
        </>
    )
        ;
};

export default ProductShare;